import { createUseStyles } from 'react-jss';

export default createUseStyles(theme => {
	return {
		question: {
			marginBottom: '1rem',
		},
	};
});
